import { useEffect, Fragment } from "react";

import { useHttpClient } from "../../shared/hooks/httpHook";
import { useForm } from "../../shared/hooks/formHook";
import { InputPrefixOutlinedFloat } from "../../shared/components/FormElements/InputPrefixOutlinedFloat";
import { ModalError } from "../../shared/components/UIElements/ModalError";
import { LoadingSpinnerOverlayRegular } from "../../shared/components/UIElements/LoadingSpinnerOverlayRegular";
import { answerChecklistItem } from "../api/checklistsAPI";
import {
  AuthContextProps,
  ChecklistData,
  KanbanFilledData,
} from "../../shared/data/types";
import { VALIDATOR_REQUIRE } from "../../shared/util/validators";

import "./SaleDash.scss";

interface SaleDashChecklistNumberProps {
  auth: AuthContextProps;
  saleId: string;
  kanbanChecklistId: string;
  kanbanChecklistItem: ChecklistData["items"][0];
  saleChecklistItem?: ChecklistData["items"][0];
  setLoadedSaleChecklist: React.Dispatch<React.SetStateAction<ChecklistData>>;
  index: number;
  type:
    | "SALES"
    | "PROJECT"
    | "INSTALLATION"
    | "AFTER_SALES"
    | "PRE_SALES"
    | "ADMINISTRATIVE";
  setLoadedData: React.Dispatch<React.SetStateAction<KanbanFilledData>>;
}

export const SaleDashChecklistNumber = (
  props: SaleDashChecklistNumberProps
) => {
  const {
    auth,
    kanbanChecklistId,
    saleId,
    kanbanChecklistItem,
    saleChecklistItem,
    setLoadedSaleChecklist,
    index,
    setLoadedData,
  } = props;
  const { error, sendRequest, clearError, isLoading } = useHttpClient();
  const { formState, inputHandler } = useForm(
    {
      [`answer${index}`]: {
        value: saleChecklistItem?.answerNumber?.toString(),
        isValid: !!saleChecklistItem?.answerNumber?.toString(),
      },
    },
    false
  );

  const onBlurHandler = () => {
    if (
      typeof +formState?.inputs?.[`answer${index}`]?.value === "number" &&
      saleChecklistItem?.answerNumber !==
        +formState?.inputs?.[`answer${index}`]?.value &&
      formState?.inputs?.[`answer${index}`]?.isValid
    ) {
      answerChecklistItem({
        sendRequest,
        auth,
        setLoadedSaleChecklist,
        saleId,
        checklistId: kanbanChecklistId,
        itemId: kanbanChecklistItem?._id,
        answer: +formState?.inputs?.[`answer${index}`]?.value,
        setLoadedData,
      });
    }
  };

  return (
    <Fragment>
      <ModalError error={error} onClear={clearError} />
      <div className="sale-dash__checklist-field">
        {isLoading && <LoadingSpinnerOverlayRegular />}
        <p className="sale-dash__checklist-task">{kanbanChecklistItem?.task}</p>
        <InputPrefixOutlinedFloat
          size="small"
          prefix=""
          id={`answer${index}`}
          type="text"
          label=""
          variant="outlined"
          validators={[VALIDATOR_REQUIRE()]}
          helperText=""
          initialValue={saleChecklistItem?.answerNumber?.toString() || ""}
          initialValid={!!saleChecklistItem?.answerNumber}
          onInput={inputHandler}
          forceError={formState?.inputs?.[`answer${index}`]?.forceError}
          reinitialize
          onBlurHandler={onBlurHandler}
        />
      </div>
    </Fragment>
  );
};
